import { TournamentTypes } from 'common';

import { InjectableHook } from 'domain/hooks';

export const TournamentLeaderboardRepository = Symbol('TournamentLeaderboardRepository');

export type ITournamentLeaderboardRepository = InjectableHook<{
  fetchTournamentLeaderboard(tournamentId: string): Promise<TournamentTypes.CourseLeaderboard[]>;
}>;
